import React from "react";
import { saveCurrentPathForRedirect } from "@lib/redirectAfterLogin";
import { StateAwareNavigate } from "@components/routes/StateAwareNavigate";

export const UnauthenticatedRoute: React.FC = () => {
    saveCurrentPathForRedirect();
    return <StateAwareNavigate to="/" replace />;
};
